import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outbreak',
  templateUrl: './outbreak.component.html',
  styleUrls: ['./outbreak.component.scss']
})
export class OutbreakComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
